__turbopack_context__.v({
  "actions": "hero-panels-module-scss-module__zMlzAa__actions",
  "backAction": "hero-panels-module-scss-module__zMlzAa__backAction",
  "card": "hero-panels-module-scss-module__zMlzAa__card",
  "continueAction": "hero-panels-module-scss-module__zMlzAa__continueAction",
  "deal": "hero-panels-module-scss-module__zMlzAa__deal",
  "field": "hero-panels-module-scss-module__zMlzAa__field",
  "fields": "hero-panels-module-scss-module__zMlzAa__fields",
  "gauge": "hero-panels-module-scss-module__zMlzAa__gauge",
  "gaugeFill": "hero-panels-module-scss-module__zMlzAa__gaugeFill",
  "gaugeLabel": "hero-panels-module-scss-module__zMlzAa__gaugeLabel",
  "gaugeMax": "hero-panels-module-scss-module__zMlzAa__gaugeMax",
  "gaugeMin": "hero-panels-module-scss-module__zMlzAa__gaugeMin",
  "gaugeNeedle": "hero-panels-module-scss-module__zMlzAa__gaugeNeedle",
  "gaugeTrack": "hero-panels-module-scss-module__zMlzAa__gaugeTrack",
  "gaugeValue": "hero-panels-module-scss-module__zMlzAa__gaugeValue",
  "metric": "hero-panels-module-scss-module__zMlzAa__metric",
  "metrics": "hero-panels-module-scss-module__zMlzAa__metrics",
  "morning": "hero-panels-module-scss-module__zMlzAa__morning",
  "panel": "hero-panels-module-scss-module__zMlzAa__panel",
  "panels": "hero-panels-module-scss-module__zMlzAa__panels",
  "profit": "hero-panels-module-scss-module__zMlzAa__profit",
  "profitBadge": "hero-panels-module-scss-module__zMlzAa__profitBadge",
  "profitValue": "hero-panels-module-scss-module__zMlzAa__profitValue",
  "progress": "hero-panels-module-scss-module__zMlzAa__progress",
  "riskCard": "hero-panels-module-scss-module__zMlzAa__riskCard",
  "riskForm": "hero-panels-module-scss-module__zMlzAa__riskForm",
  "riskHeader": "hero-panels-module-scss-module__zMlzAa__riskHeader",
  "riskTitle": "hero-panels-module-scss-module__zMlzAa__riskTitle",
  "score": "hero-panels-module-scss-module__zMlzAa__score",
  "scoreCard": "hero-panels-module-scss-module__zMlzAa__scoreCard",
  "scoreHeader": "hero-panels-module-scss-module__zMlzAa__scoreHeader",
  "scoreMain": "hero-panels-module-scss-module__zMlzAa__scoreMain",
  "scoreTitle": "hero-panels-module-scss-module__zMlzAa__scoreTitle",
  "scoreTop": "hero-panels-module-scss-module__zMlzAa__scoreTop",
  "segments": "hero-panels-module-scss-module__zMlzAa__segments",
  "share": "hero-panels-module-scss-module__zMlzAa__share",
  "side": "hero-panels-module-scss-module__zMlzAa__side",
  "startAction": "hero-panels-module-scss-module__zMlzAa__startAction",
  "story": "hero-panels-module-scss-module__zMlzAa__story",
  "storyBackdrop": "hero-panels-module-scss-module__zMlzAa__storyBackdrop",
  "storyContent": "hero-panels-module-scss-module__zMlzAa__storyContent",
  "storyGlow": "hero-panels-module-scss-module__zMlzAa__storyGlow",
  "storyTexture": "hero-panels-module-scss-module__zMlzAa__storyTexture",
  "storyTitle": "hero-panels-module-scss-module__zMlzAa__storyTitle",
  "symbol": "hero-panels-module-scss-module__zMlzAa__symbol",
  "symbolArrow": "hero-panels-module-scss-module__zMlzAa__symbolArrow",
  "symbolDivider": "hero-panels-module-scss-module__zMlzAa__symbolDivider",
  "symbolDot": "hero-panels-module-scss-module__zMlzAa__symbolDot",
  "user": "hero-panels-module-scss-module__zMlzAa__user",
  "wrapped": "hero-panels-module-scss-module__zMlzAa__wrapped",
});
